import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import english from "./locales/en/translation.json";
import latinAmericanSpanish from "./locales/es-419/translation.json";

export const SBS_LANGUAGES = [
  { code: "en", label: "English", shortLabel: "EN" },
  { code: "es-419", label: "Español (Latinoamérica)", shortLabel: "ES" },
];

export function normalizeSBSLanguage(value) {
  const language = String(value || "").toLowerCase();
  return language.startsWith("es") ? "es-419" : "en";
}

function initialLanguage() {
  try {
    const stored = window.localStorage.getItem("sbs.language");
    if (stored) return normalizeSBSLanguage(stored);
  } catch (error) {
    console.warn("SBS language preference could not be read.", error);
  }

  return normalizeSBSLanguage(window.navigator?.language);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: english },
    "es-419": { translation: latinAmericanSpanish },
  },
  lng: initialLanguage(),
  fallbackLng: "en",
  supportedLngs: SBS_LANGUAGES.map((language) => language.code),
  nonExplicitSupportedLngs: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

function applyDocumentLanguage(language) {
  const normalized = normalizeSBSLanguage(language);
  document.documentElement.lang = normalized;
  try {
    window.localStorage.setItem("sbs.language", normalized);
  } catch (error) {
    console.warn("SBS language preference could not be saved on this device.", error);
  }
}

applyDocumentLanguage(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", applyDocumentLanguage);

export default i18n;
